module.exports = __webpack_public_path__ + "static/escelade-bf3370adf5c8d95f65c25586e39b0c11.jpg";